import inView from 'in-view';

export default class InView {
    constructor() {
        this.configureInView();
    }

    configureInView() {
        // Bind the 'enter' event to elements with the 'data-inview' attribute
        inView('[data-inview]').on('enter', this.handleEnter);

        // Set an offset of 150 pixels to trigger 'enter' before elements are fully in view
        inView.offset(150);
    }

    handleEnter(el) {
        // Add the 'inview' class when the element enters the viewport
        el.classList.add('inview');
    }
}
